// extracted by mini-css-extract-plugin
module.exports = {"cart-quantity-widget":"_3dY_ZR","quantity-button":"_23FHuj","quantity-text":"_26HdzL","disabled":"_3UDv-f","quantity-input":"_253qQJ"};